module.exports = __webpack_public_path__ + "img/435.8f1a32cc.png";